import React from "react";
import QuoteInfo from "components/QuoteInfo.js";
import {getRequests, postRequest} from "../helpers/ApiHelper";
import { withRouter } from "react-router-dom";
import { FormComponent, FormContainer } from "react-authorize-net";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {
    PayPalScriptProvider,
    PayPalButtons,
} from "@paypal/react-paypal-js";

const MySwal = withReactContent(Swal)
let clientKey = '8WFSANB37U87eh5EuJf6nP8sY2hZ85SPs282QMQ524Zxyqeq4HgnhZ3scmXJ4Eaz';
let apiLoginId = '6Car28BQ7yj4';

const ErrorComponent = () => (
    <div>
        <p>
            Failed to process payment
        </p>
    </div>
);
 class BookingPayment extends React.Component {
     quote={};
     fleet={};
     startAddressType='';
     extra={};
     amount = 0;
     _isMounted = false;

    quoteLoading = true;
    paypalCliendId = "AaP8nt3NwG3zMXFX_qT_G9OpZl8ajLp8oW17FHntBTRjLpWdNN37IlM30iqKJ3NYEDoTDCiYAUf5-zQm";
    quoteFleetLoading = true;
     state = {
         status:'unpaid',
         error: ''
     };

    constructor(props) {
        super(props);
        this.onSuccessHandler = this.onSuccessHandler.bind(this);
        this.onErrorHandler = this.onErrorHandler.bind(this);
        this.paypalonApprove = this.paypalonApprove.bind(this);
        this.confirmBooking = this.confirmBooking.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
        const quoteId =   localStorage.getItem('quoteId');
        const quoteFleetId =   localStorage.getItem('quoteFleetId');
        let quoteExtra =   localStorage.getItem('quoteExtra');
        const startAddressType =   localStorage.getItem('airportLocation');

         quoteExtra =   JSON.parse(quoteExtra);
        if(quoteId !== undefined && quoteFleetId !== undefined){
            getRequests('quote/'+quoteId).then(data => {
                getRequests('quote-fleet/'+quoteFleetId).then(fleetData => {
                    if(this._isMounted){
                        const amount = (fleetData.total * fleetData.fleet_count);
                        this.startAddressType = startAddressType;
                        this.quoteLoading = false;
                        this.quoteFleetLoading = false;
                        this.quote = data;
                        this.fleet = fleetData;
                        this.extra = quoteExtra;
                        // this.paypalCliendId = fleetData.paypalCliendId;
                        this.amount =  amount;
                        this.setState(this.state);
                    }
                });
            });

        }
    }

     onErrorHandler = (response) => {
         this.setState({
             error:  response.messages.message.map(err => err.text)
         });
     };
     componentWillUnmount() {
         this._isMounted = false;
     }
     paypalButtonOptions(data, actions) {
         return actions.order.create({
             purchase_units: [{
                 amount: {
                     description : this.extra.passenger_name,
                     currency_code: 'USD',
                     value: this.amount
                 }
             }]
         });
     }
     paypalonApprove(data, actions) {
         this.confirmBooking(data,'paypal');
         // postRequest('paypal-checkout',data).then(res => {
         //        console.log(res)
         // });
         // // return actions.order.capture().then((details) => {
         // //     console.log(details);
         // //    // this.confirmBooking(details,'paypal');
         // // });
     }
     confirmBooking(paymentData,type) {
         MySwal.fire({
             title:"",
             text:"Generating Booking.. please wait",
             icon: "https://www.boasnotas.com/img/loading2.gif",
             buttons: false,
             allowOutsideClick: false,
             showCancelButton: false,
             showConfirmButton: false
         });
         const data = {extra:this.extra};
         data.quote_id = this.quote.id;
         data.quote_fleet_id = this.fleet.id;
         data.payment = paymentData;
         data.payment_type = type;

         postRequest('book-confirm',data).then(res => {
             MySwal.close();

             if(res && res.status === 'success'){
                 localStorage.removeItem("quoteId");
                 localStorage.removeItem("quoteFleetId");
                 localStorage.removeItem("quoteExtra");
                 localStorage.setItem("booking_token",res.booking_token);
                 this.props.history.push('/book-thank-you');
             }else{
                 MySwal.fire({
                     title:"",
                     text:res.message,
                     type: 'error',
                 });
                 this.setState({
                     status:  'unpaid',
                     error:  res.message
                 });
             }
         },error => {
             MySwal.close();
             MySwal.fire({
                 title:"",
                 text:"Error While generating Booking",
                 type: 'error',
             });

         });
     }

     onSuccessHandler = (response) => {
         this.setState({
             status:  'paid'
         });
         this.confirmBooking(response,'card');

     };
    render() {

        return (
            <section className="booking-flow-wrapper section-gap  ">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="booking-sidebar-wrapper">
                                <h4>Booking Information</h4>
                                {this.quoteLoading &&

                                <div className="loader-wrapper">
                                    <div className="  loader">
                                        <span>L</span>
                                        <span>o</span>
                                        <span>a</span>
                                        <span>d</span>
                                        <span>i</span>
                                        <span>n</span>
                                        <span>g</span>
                                    </div>
                                </div>

                                }
                                {!this.quoteLoading &&
                                    <QuoteInfo quoteData={this.quote} fleetData={this.fleet}/>
                                }

                            </div>
                        </div>

                        <div className="col-md-8">
                            { this.extra.payment_type === 'card' &&
                            <div className="booking-form-wrapper booking-confirm-page">
                                {this.state.status === "paid" ? (
                                    <p>
                                        Processing Payment & Generating Booking ...
                                    </p>
                                ) : this.state.status === "unpaid" ? (
                                    <FormContainer
                                        environment="production"
                                        onError={this.onErrorHandler}
                                        onSuccess={this.onSuccessHandler}
                                        amount={this.amount}
                                        component={FormComponent}
                                        clientKey={clientKey}
                                        apiLoginId={apiLoginId}
                                    />
                                ) : this.state.error !== "" ? (
                                    <ErrorComponent
                                        onBackButtonClick={() => this.setState({status: "unpaid"})}
                                        errors={this.state.error}
                                    />
                                ) : null}
                            </div>
                            }
                            {this.extra.payment_type === 'paypal' &&
                            <PayPalScriptProvider options={{"client-id": this.paypalCliendId}}>
                                <PayPalButtons createOrder={ (data, actions) => this.paypalButtonOptions(data, actions)} onApprove={ (data, actions) => this.paypalonApprove(data, actions)}/>
                            </PayPalScriptProvider>
                            }
                            <div className="booking-form-wrapper booking-confirm-page">
                                <form>
                                    <h4>Personal Information</h4>
                                    <div className="row no-gutter">
                                        <div className="col-md-4">
                                            <label htmlFor="name">Full Name</label>
                                            <p>{this.extra.passenger_name}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="email">Email Address</label>
                                            <p>{this.extra.passenger_email}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="phone">Phone Number</label>
                                            <p>{this.extra.passenger_mobile}</p>
                                        </div>
                                    </div>
                                    <h4>Travel Details</h4>
                                    <div className="row no-gutter">
                                        <div className="col-md-3">
                                            <label htmlFor="pax">No. of Passenger</label>
                                            <p>{this.extra.passenger_count}</p>
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="pax">No. of Luggage</label>
                                            <p>{this.extra.luggage_count}</p>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="pax">Toddler Seat</label>
                                            <p>{this.extra.child_seat_count}</p>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="pax">Infant Seat</label>
                                            <p>{this.extra.infant_seat_count}</p>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="pax">Booster Seat</label>
                                            <p>{this.extra.booster_seat_count}</p>
                                        </div>
                                        {/* <div className="col-md-3">
                                            <label htmlFor="pax">Waiting Time</label>
                                            <p>{this.extra.waiting_time} Minutes</p>
                                        </div> */}
                                        <div className="col-md-6 pt-4">
                                            <label htmlFor="pick-address ">PickUp address line</label>
                                            <p>{this.extra.pickup_address_line}</p>
                                        </div>
                                        <div className="col-md-6 pt-4">
                                            <label htmlFor="drop-address  ">Dropoff address line</label>
                                            <p>{this.extra.dropoff_address_line}</p>
                                        </div>
                                    </div>
                                    {(this.startAddressType === 'airport' || ( this.startAddressType !== 'airport' && this.quote.trip_type === 'round_trip' )) &&
                                    <h4>Flight Information</h4>}
                                    {(this.startAddressType === 'airport' || ( this.startAddressType !== 'airport' && this.quote.trip_type === 'round_trip' )) &&
                                    <div className="row no-gutter">
                                        <div className="col-md-6">
                                            <label htmlFor="airlinename">Airline Name</label>
                                            <p>{this.extra.airline_name}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="flighnum">Flight Number</label>
                                            <p>{this.extra.flight_number}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="arivaltime">Flight Arrival Time</label>
                                            <p>{this.extra.arrival_time}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="messgaeboard">
                                                Name or Message on the pickup sign
                                            </label>
                                            <p>{this.extra.message_board}</p>
                                        </div>
                                    </div>

                                    }
                                    {this.quote.trip_type === 'round_trip' &&
                                    <h4>Return Journey Information</h4>
                                    }
                                    {this.quote.trip_type === 'round_trip' &&
                                    <div className="row no-gutter">
                                        <div className="col-md-6">
                                            <label htmlFor="messgaeboard">
                                                Return Pickup Date
                                            </label>
                                            <p>{this.quote.return_pickup_date}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="messgaeboard">
                                                Return Pickup Time
                                            </label>
                                            <p>{this.quote.return_pickup_time}</p>
                                        </div>
                                    </div>
                                    }
                                    {(this.startAddressType !== 'airport' || (this.startAddressType === 'airport' && this.quote.trip_type === 'round_trip')) &&
                                    <h4>Departure Flight Information</h4>
                                    }
                                    {(this.startAddressType !== 'airport' || ( this.startAddressType === 'airport' && this.quote.trip_type === 'round_trip' )) &&
                                    <div className="row no-gutter">

                                        <div className="col-md-6">
                                            <label htmlFor="messgaeboard">
                                                Airline Name
                                            </label>
                                            <p>{this.extra.return_airline_name}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="messgaeboard">
                                                Flight Number
                                            </label>
                                            <p>{this.extra.return_flight_number}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="messgaeboard">
                                                Flight Departure Time
                                            </label>
                                            <p>{this.extra.return_arrival_time}</p>
                                        </div>
                                    </div>


                                    }
                                </form>
                            </div>

                        </div>


                    </div>
                </div>
            </section>
        );

    }
}
export default withRouter(BookingPayment);
